import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20v-15a1 1 0 0 1 1 -1h15","key":"svg-0"}]]

const IconBorderCornerSquare = createReactComponent('outline', 'border-corner-square', 'BorderCornerSquare', __iconNode);

export default IconBorderCornerSquare;